export default __webpack_public_path__ + "static/media/miguel-lopes-12.f0531b79.jpg";